import { defineComponent as g, computed as b, onMounted as h, ref as B, resolveComponent as I, openBlock as n, createElementBlock as a, normalizeClass as s, withDirectives as M, createElementVNode as u, createVNode as R, Transition as V, withCtx as w, toDisplayString as D, createCommentVNode as l, unref as L, Fragment as P, renderList as S, createBlock as U } from "vue";
import W from "../../node_modules/v-wave/dist/es/index.mjs";
const $ = ["data-test"], z = ["title"], F = { key: 0 }, q = /* @__PURE__ */ g({
  __name: "IstMainNavigationItem",
  props: {
    item: {},
    currentRouteName: {},
    closed: { type: Boolean },
    offset: { type: Boolean }
  },
  emits: ["menuClicked"],
  setup(d, { emit: c }) {
    const { vWave: v } = W.createLocalWaveDirective(), p = c, f = b(() => i.currentRouteName == i.item.name), k = () => {
      var e;
      return i.item.menuEntries ? (e = i.item.menuEntries) == null ? void 0 : e.some((o) => o.name === i.currentRouteName) : !1;
    };
    h(() => {
      t.value = k();
    });
    const y = (e) => {
      if (e !== "")
        return "pointer";
    }, m = (e) => {
      if (e.menuEntries && !e.entryPointUrl) {
        t.value = !t.value;
        return;
      }
      p("menuClicked", e);
    }, N = (e) => {
      t.value = e.entryPointUrl ? !t.value : t.value;
    }, i = d, t = B(i.item.expand ?? !1);
    return (e, o) => {
      const C = I("IstMainNavigationItem", !0);
      return n(), a("div", {
        class: s({ offset: e.offset }),
        "data-test": `menu-item-${e.item.name}`
      }, [
        M((n(), a("a", {
          tabindex: "0",
          class: s(["ist-list-item", { active: f.value, closed: e.closed }]),
          role: "listitem",
          onClick: o[1] || (o[1] = (r) => m(e.item))
        }, [
          u("span", {
            class: s(["ist-list-item_icon mdi " + e.item.iconName, "notranslate"]),
            "aria-hidden": "true",
            title: e.item.title
          }, null, 10, z),
          R(V, {
            name: "fade",
            appear: ""
          }, {
            default: w(() => [
              e.closed ? l("", !0) : (n(), a("label", {
                key: 0,
                class: s(["ist-menu-label", y(e.item.entryPointUrl)])
              }, D(e.item.title), 3))
            ]),
            _: 1
          }),
          e.item.menuEntries && !e.closed ? (n(), a("div", F, [
            u("span", {
              class: s({
                "mdi mdi-chevron-up": t.value,
                "mdi mdi-chevron-down": !t.value
              }),
              onClick: o[0] || (o[0] = (r) => N(e.item))
            }, null, 2)
          ])) : l("", !0)
        ], 2)), [
          [L(v)]
        ]),
        e.item.menuEntries && t.value ? (n(), a("nav", {
          key: 0,
          class: s(["deep", { expanded: t.value }]),
          "aria-labelledby": "sitemenu"
        }, [
          (n(!0), a(P, null, S(e.item.menuEntries, (r, E) => (n(), U(C, {
            key: E,
            item: r,
            closed: e.closed,
            offset: r.offset,
            "current-route-name": e.currentRouteName,
            onMenuClicked: m
          }, null, 8, ["item", "closed", "offset", "current-route-name"]))), 128))
        ], 2)) : l("", !0)
      ], 10, $);
    };
  }
});
export {
  q as default
};
